/**
 * Created by razial on 10.06.2025.
 */

const SpawnerView = cc.Node.extend({
    ctor: function (spawner, unitView) {
        this.spawner = spawner;
        this.unitView = unitView;

        this._super();

        if (this.spawner.unit.getData().guide) {
            this.createGuideButton();
        }

        this.restoreState(false);
    },

    restoreState: function (animated) {
        if (this.spawner.noSpace) {
            this.removeTimer(animated);
            this.switchAnimation("no_space");
        } else if (this.spawner.getTimeLeft()) {
            this.createTimer(animated);
            this.switchAnimation(this.spawner.countPrizes() ? "idle" : "work");
        } else {
            this.removeTimer(animated);
            this.switchAnimation("active_idle");
        }
        this.toggleButton(this.spawner.canSpeedUp());
    },

    switchAnimation: function (animation) {
        if (this.unitView.sprite instanceof cleverapps.Spine) {
            this.unitView.sprite.setAnimation(0, animation, true);
        }
    },

    createGuideButton: function () {
        const styles = cleverapps.styles.SpawnerView;

        this.guideButton = new cleverapps.UI.HelpButton({
            callback: () => {
                const guideOptions = this.spawner.unit.getData().guide;
                cleverapps.focusManager.display({
                    focus: "SpawnerGuideWindow",
                    action: (f) => {
                        new GuideWindow(guideOptions[cleverapps.meta.selectedLocationId()] || guideOptions.default, {
                            code: this.spawner.unit.code,
                            stage: Families[this.spawner.unit.code].units.length - 1
                        });
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        });
        this.guideButton.setAlignment(styles.guideButton);
        this.addChild(this.guideButton);
    },

    createButton: function (timeLeft) {
        const styles = cleverapps.styles.SpawnerView.timer;
        if (this.button) {
            this.button.removeFromParent();
            delete this.button;
        }
        this.speedUpPrice = Unit.CalcSpeedUPPrice(timeLeft);
        const button = this.button = new UseGoldButton({
            price: this.speedUpPrice,
            source: this.spawner.unit,
            filter: () => this.spawner.canSpeedUp(),
            onClicked: () => this.spawner.speedUpCharging(),
            eventName: cleverapps.EVENTS.SPENT.SPAWNER,
            type: cleverapps.styles.UI.Button.Images.button_blue,
            width: styles.button.width,
            height: styles.button.height,
            speedUp: true
        });

        button.setAlignment(styles.button);
        this.timer.addChild(button);
    },

    toggleButton: function (enabled) {
        if (this.button) {
            if (enabled) {
                this.button.enable();
            } else {
                this.button.disable();
            }
        }
    },

    createTimer: function (animated) {
        const timeLeft = this.spawner.getTimeLeft();

        const additionalView = this.unitView.getAdditionalView("timer");
        if (additionalView) {
            additionalView.view.resetTimeLeft(timeLeft);
            this.createButton(timeLeft);
            return;
        }

        const styles = cleverapps.styles.SpawnerView.timer;

        const timer = this.timer = new ComponentTimer(new cleverapps.CountDown(
            timeLeft,
            {
                onTick: () => {
                    const timeLeft = this.spawner.getTimeLeft();
                    if (this.speedUpPrice !== Unit.CalcSpeedUPPrice(timeLeft)) {
                        this.createButton(timeLeft);
                    }
                }
            }
        ));
        timer.setAlignment(styles);

        if (animated) {
            this.unitView.animateAppearAdditionalView("timer", timer);
        } else {
            this.unitView.createAdditionalView("timer", timer);
        }
        this.createButton(timeLeft);
    },

    removeTimer: function (animated) {
        this.unitView.removeAdditionalView("timer", !animated);
    }

});

cleverapps.styles.SpawnerView = {
    timer: {
        x: { align: "center" },
        y: { align: "bottom", dy: 10 },
        button: {
            height: 50,
            width: 130,
            x: { align: "center" },
            y: { align: "bottom", dy: -70 }
        }
    },
    guideButton: {
        x: { align: "right", dx: 150 },
        y: { align: "top", dy: 150 }
    }
};